import { ConfirmDialogProvider } from "common/modal/ConfirmDialog";
import { KeyboardEventsProvider } from "common/nav/provider/KeyboardEvents/KeyboardEvents";
import { MAIN_THEME } from "constant/theme/theme.constant";
import React from "react";
import { ThemeProvider } from "styled-components";

type CitajteoCommonProps = { children: React.ReactNode };

export default function CitajteoCommon({ children }: CitajteoCommonProps) {
  return (
    <ThemeProvider theme={MAIN_THEME}>
      <ConfirmDialogProvider>
        <KeyboardEventsProvider>{children}</KeyboardEventsProvider>
      </ConfirmDialogProvider>
    </ThemeProvider>
  );
}
